import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { CoreModule } from '../core';
import { ReportRoutingModule } from './report-routing.module';
import { FinancialReportComponent } from './financial.report.component';
import { FusionChartsModule } from 'angular-fusioncharts';
import * as FusionCharts from 'fusioncharts';
import * as Charts from 'fusioncharts/fusioncharts.charts';
import * as FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';

FusionChartsModule.fcRoot(FusionCharts, Charts, FusionTheme);

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgSelectModule, FusionChartsModule,
    CoreModule, ReportRoutingModule],
  declarations: [FinancialReportComponent]
})
export class ReportModule { }
